module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/eyecatch-problem-01-542551b2a268d20d8ed39852fbe9031a.png";